import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-all-redeemption',
  templateUrl: './view-all-redeemption.page.html',
  styleUrls: ['./view-all-redeemption.page.scss'],
})
export class ViewAllRedeemptionPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
